export const COLORS = {
	error: 'rgb(255 74 74 / 65%)'
}
